<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters">
				<el-form-item>
					<el-input v-model="filters.title" placeholder="标题"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" v-on:click="getInfos">查询</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="handleAdd">新增</el-button>
				</el-form-item>
			</el-form>
		</el-col>

		<!--列表-->
		<el-table :data="infos" border stripe highlight-current-row v-loading="listLoading" @selection-change="selsChange" @sort-change="sortChange" style="width: 100%;"
		:header-row-style="{backgroundColor:'#eef1f6',lineHeight:'20px',color:'#000'}" :row-style="{height:'30px'}">
			<el-table-column type="selection"  min-width="40">
			</el-table-column>
			<el-table-column type="index" label="编号"  width="80">
			</el-table-column>	
			<el-table-column prop="show_type_name" label="推文类型" width="200" >
			</el-table-column>	
			<el-table-column prop="title" label="标题" width="200" >
			</el-table-column>
			<el-table-column prop="content" label="概要描述" width="300" >
			</el-table-column>
			<el-table-column prop="maker_name" label="创建人" width="80" >
			</el-table-column>
			<el-table-column prop="make_date" label="创建时间" width="180" >
			</el-table-column>
			<el-table-column label="操作" min-width="140">
				<template slot-scope="scope">
					<el-button size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
					<el-button type="danger" size="small" @click="handleDel(scope.$index, scope.row)">删除</el-button>
					<el-button type="primary" size="small" @click="handleRelease(scope.$index, scope.row)">发布</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-col :span="8"> <el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除</el-button></el-col>
			<el-col :span="8">
				<el-pagination @size-change="handleSizeChange"  @current-change="handleCurrentChange" :current-page="currentPage"
							:page-sizes="[20, 50, 80, 100]" :page-size="pageSize"  layout="total, sizes, prev, pager, next, jumper" :total="total" style="float:left;">
				</el-pagination>
			</el-col>
		</el-col>

		<!--编辑界面-->
		<el-dialog title="编辑" :visible.sync="editFormVisible" :close-on-click-modal="false" @close="cancelSubmit"  size="small" >
			<el-form :model="editForm"    label-width="100px" :rules="editFormRules" ref="editForm">
				<el-form-item label="推文类型" prop="show_type"  >
					<el-select v-model="editForm.show_type"  placeholder="请选择" style="width:400px;" @change="showTypeChange">
                        <el-option  v-for="(item,index) in showTypes" :key="index" :label="item.group_name"  :value="item.group_code"> </el-option>
                    </el-select>
				</el-form-item>	   

				<el-form-item label="标题" prop="title">
					<el-input v-model="editForm.title" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="概要描述" prop="content">
				     <el-input type="textarea"  :rows="2" v-model="editForm.content" auto-complete="off"></el-input>
				</el-form-item>

				<el-form-item label="音/视频名称" prop="play_name"  v-if="editForm.show_type>0">
					<el-input v-model="editForm.play_name" auto-complete="off"></el-input>
				</el-form-item>

				<el-form-item label="作者" prop="author"  v-if="editForm.show_type>0">
					<el-input v-model="editForm.author" auto-complete="off"></el-input>
				</el-form-item>

				<el-form-item label="音/视频时长" prop="duration"  v-if="editForm.show_type>0">
					<el-input v-model="editForm.duration" auto-complete="off"></el-input>
				</el-form-item>

				<el-form-item label="上传音频" v-if="editForm.show_type=='2'" >
				<el-upload :action="audioupload"  :on-success="handleAudioSuccess" :file-list="editForm.audio" :on-remove="handleAudioRemove">
				<el-button size="small" type="primary">点击上传</el-button>				
				</el-upload>
				</el-form-item>			

                <el-form-item  label="上传视频" v-if="editForm.show_type!='2'" >
				<el-upload  :action="videoupload" :on-success="handleVideoSuccess" :file-list="editForm.video" :on-remove="handleVideoRemove">
				<el-button size="small" type="primary">点击上传</el-button>				
				</el-upload>
				</el-form-item>

				<el-form-item label="上传歌词/字幕"  v-if="editForm.show_type>0">
				<el-upload :action="lyricupload" :on-success="handleLyricSuccess" :file-list="editForm.lyric_tmp" :on-remove="handleLyricRemove">
				<el-button size="small" type="primary">点击上传</el-button>				
				</el-upload>
				</el-form-item>

                <el-form-item label="上传缩略图" >
				<el-upload :action="imageupload" list-type="picture-card" ref="upload" :limit="1" :file-list="editForm.img_url_tmp" :on-remove="handleRemove" :on-success="handlePictureSuccess">
				<i class="el-icon-plus"></i>
				</el-upload>

				<el-dialog v-model="dialogVisible" size="tiny">
						<img width="100%" :src="dialogImageUrl" alt="">
				</el-dialog>
				</el-form-item>

				<el-form-item label="对应文章" prop="article_id" >
					 <el-select v-model="editForm.article_id" clearable filterable   placeholder="请选择" @change="articleChange" style="width:400px;">
                        <el-option  v-for="(item,index) in articles" :key="index"  :label="item.title"  :value="item.id"> </el-option>
                     </el-select>
				</el-form-item>
                <!--
				<el-form-item label="对应词汇" prop="words">
				     <el-input type="textarea"  :rows="2" v-model="editForm.words" auto-complete="off"></el-input>
					 <div style="color:red;">对应单词为单词id,多个单词id用英文半角逗号分隔</div>
				</el-form-item>	
                  -->
				<el-form-item label="搜索关键词" prop="words">
				     <el-input type="textarea"  :rows="2" v-model="editForm.keyword" auto-complete="off"></el-input>					 
				</el-form-item>					
                
              <el-form-item label="" >					
					 <el-checkbox v-model="editForm.stop_flag">停用</el-checkbox>					
				</el-form-item>		 
		
			</el-form>


			<div style="margin:2px 0px 6px 0px;">
					<el-button type="primary" @click="showWord">添加单词</el-button>
			</div>

			<el-dialog size="small" title="选择单词" :visible.sync="innerVisible" append-to-body>
				<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
					<el-form :inline="true" :model="wordfilters">
						<el-form-item>
							<el-input v-model="wordfilters.word" placeholder="单词"></el-input>
						</el-form-item>						
						<el-form-item>
							<el-button type="primary" v-on:click="getWord">查询</el-button>
						</el-form-item>
					</el-form>				
				</el-col>
             
				<!--列表-->
				<el-table :data="words"  height="350" border stripe highlight-current-row v-loading="wordlistLoading" @selection-change="selsChange" @sort-change="wordSortChange"
				style="width: 100%;" :header-row-style="{backgroundColor:'#eef1f6',lineHeight:'20px',color:'#000'}" :row-style="{height:'30px'}">
					
					<el-table-column type="selection"  min-width="40">
					</el-table-column>				
					<el-table-column prop="word" label="单词"  width="200">
					</el-table-column>
					<el-table-column prop="part_of_speech" label="词性"  width="80">
					</el-table-column>			
					<el-table-column prop="chinese" label="简要释义"  >
					</el-table-column>						
					
				</el-table>

				<!--工具条-->
			       <div  class="toolbar">
						<el-pagination @size-change="handleWordSizeChange"  @current-change="handleWordChange" :current-page="wordPage"
									:page-sizes="[20, 50, 80, 100]" :page-size="wordSize"  layout="total, sizes, prev, pager, next, jumper" :total="wordTotal">
						</el-pagination>
			        </div>
					<span slot="footer" class="dialog-footer">
						<el-button @click="innerVisible=false;">取 消</el-button>
						<el-button type="primary" @click="hideWord">确 定</el-button>
					</span>
            </el-dialog>
			<el-table :data="wordData" height="350" border stripe highlight-current-row v-loading="listLoading" @selection-change="selsChange" @sort-change="sortChange"
			style="width: 100%;" :header-row-style="{backgroundColor:'#eef1f6',lineHeight:'20px',color:'#000'}" :row-style="{height:'30px'}">
				<el-table-column prop="word" label="单词" width="250"></el-table-column>
				<el-table-column prop="part_of_speech" label="词性" width="200"></el-table-column>
				<el-table-column prop="chinese" label="简要释义"></el-table-column>
				<el-table-column label="操作" min-width="140">
					<template slot-scope="scope">
							<el-button  @click.native.prevent="deleteRow(scope.$index, wordData)" type="text"  size="small">移除</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="editFormVisible = false;">取消</el-button>
				<el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
			</div>
		</el-dialog>

	
	</section>
</template>

<script>
	//import util from '../../common/js/util'

	import { getDiscoveryListPage,getWordListPage,getWordSubListPage,addDiscoveryInfo,editDiscoveryInfo, removeDiscoveryInfo,batchremoveDiscoveryInfo,getDiscoveryInfoBase,upload,uploadDiscovery,imgDel,imgsDel,articleUrl,runType } from '../../api/api';
 
 let CurrentUserID="",Session=""; 
 
	export default {
		data() {
			return {
				filters: {
					title: ''
				},
				wordfilters:{
					word:''
				},	
				dialogImageUrl: '1',
                dialogVisible: false,
				imageupload:uploadDiscovery+'?runType='+runType+'&type=1&CurrentUserID='+sessionStorage.getItem('userID')+'&Session='+sessionStorage.getItem('session'),
				audioupload:upload+'?runType='+runType+'&type=2&CurrentUserID='+sessionStorage.getItem('userID')+'&Session='+sessionStorage.getItem('session'),
				videoupload:upload+'?runType='+runType+'&type=3&CurrentUserID='+sessionStorage.getItem('userID')+'&Session='+sessionStorage.getItem('session'),
				lyricupload:upload+'?runType='+runType+'&type=4&CurrentUserID='+sessionStorage.getItem('userID')+'&Session='+sessionStorage.getItem('session'),
				selectchangeflag:0,		
				infos:[],		
				showTypes:[],
				articles:[],
				words: [],
				wordData:[],
				total: 0,
				pageSize:20,
				currentPage: 1,
				wordTotal:0,
				wordSize:20,
                wordPage:1,
				listLoading: false,
				wordlistLoading: false,
				sels: [],//列表选中列
                 prop:"", 
				 order:"",
				wordprop:"", 
				wordorder:"",
				editFormVisible: false,//编辑界面是否显示
				editLoading: false,
				editFormRules: {
					content: [
						{ required: true, message: '概要描述', trigger: 'blur' }
					],
					title:[ {  required: true, message: '请输入标题', trigger: 'blur' }]
					
				},
				 edit_img_url:[], //修改时添加的图片数组
				 del_tmp:[],  //修改时删除原有图片的数组，提交时进行处理
				innerVisible:false,
				//编辑界面数据
				editForm: {
					id: 0,					
					title:'',
					content:'',			
					show_type:'1',                     
					img_url_tmp:[],
					article_id:'',
					article_url:'',						
					play_name:'',
					author:'',
					duration:'',
					video:[],
					video_url:'',		
					audio:[],
					audio_url:'',		
					lyric_tmp:[],
					stop_flag:false,
					//words:'',
					keyword:''

             
				},
				
				formStatus: 0   //界面状态 0新增 1修改 2查看

			}
		},
		methods: {
			cancelSubmit:function(){
               
				if(this.formStatus==0)
				{
			
						if (this.editForm.img_url_tmp.length>0){
							this.imgDel(JSON.stringify(this.editForm.img_url_tmp),true);
							
							
						}
			 }
			 if(this.formStatus==1)
			 {
                 
				 		if (this.edit_img_url.length>0){
							
				            this.imgDel(JSON.stringify(this.edit_img_url),true);							
							
						}

			 }
               this.editForm.img_url_tmp=[];
               this.edit_img_url.length=[];
			   this.del_tmp=[];	 
			   if (this.$refs['editForm'] !== undefined) {						
                    this.$refs['editForm'].resetFields();
                }
			},
			 handleSizeChange(val) {
				this.pageSize=val;                 
				this.getInfos();
             },		
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getInfos();
			},
			handleWordSizeChange(val) {
				
				this.wordSize=val;                 
				this.getWord();
				this.setselect();

		
				
             },		
			handleWordChange(val) {
				
				this.wordPage = val;
				this.getWord();
				this.setselect();
			},  
			showWord()
			{
				this.innerVisible = true;
				this.wordfilters.word='';
				this.getWord();
			},
			hideWord()
			{
				this.innerVisible = false;
				this.setselect();
			},
			  deleteRow(index, rows) {
                rows.splice(index, 1);
            },
			setselect()
			{				
              	var a = this.wordData.concat(this.sels);

				for(var i=0; i<a.length-1;i++)
				{
					for(var j=i+1; j<a.length;j++)
					{
						if(a[i].word_id == a[j].word_id)
						{
							
						   a.splice(j, 1);
						  
						}
					}
				}
             
				this.wordData=a;
                this.sels=[];
			} , 

		   getWord:function(){
                               
				 let para = {
					 CurrentUserID:CurrentUserID,					
				    currentPage: this.wordPage,
					pageSize:this.wordSize,
					word: this.wordfilters.word,										
					sortName:this.wordprop,
					sortOrder:this.wordorder,
					Session:Session
				};
				this.wordlistLoading = true;				

                this.$http.jsonp(getWordListPage, {params: para}).then(
                   function(res){                         
                         if (res.data.result_code==200)
                         {
							 this.wordTotal = res.data.infolist.total;
					         this.words = res.data.infolist.infos;
					         this.wordlistLoading = false;
                           
                         }
                         else{                           
                              
                             this.wordlistLoading = false;
							 
							 if (res.data.result_code==911)
							  {
                                 this.$router.push({ path: "/login"});
								  return;
							  }

                              if (res.data.result_code==600)
							  {
									this.$message({
										message:'接口错误',
										type: 'error'
									});
                                  return;
							  }
							
                         }
                       

                   },
                   function(res)
                   {
                        this.$message({
                                message:'接口访问失败',
                                type: 'error'
                              });
                      this.wordlistLoading = false;
                   }
           )

			}, 
	  imgDel(filename,Multiple){
                    
					var imgUrl=imgDel;
		            if (Multiple)
					{
                         imgUrl=imgsDel;
					}
      				this.$http.jsonp(imgUrl,{params: {CurrentUserID:CurrentUserID,Session:Session,fileName:filename,type:1,runType:runType}}).then(
						function(res){                         
							if (res.data.result_code!=200)
							{                           
								this.$message({
								message:'删除文件错误',
								type: 'error'
								});
							}
						},
						function(res)
						{
							this.$message({
									message:'删除文件错误',
									type: 'error'
									});
							
						});

	  },
	  handleRemove(file, fileList) {
		     
             for(var i=0; i<this.editForm.img_url_tmp.length; i++) {
				if(this.editForm.img_url_tmp[i].name == file.name) {				  
				   	if(this.formStatus==0)
	             	{		
					   this.editForm.img_url_tmp.splice(i, 1);			  
                       this.imgDel(file.name,false);
		            }
					if (this.formStatus==1)
					{					
                          this.del_tmp.push({name:file.name});
                           
					}
				   
				break;
				}
			 }
			

		if(this.formStatus==1)
		{
              
		     for(var i=0; i<this.edit_img_url.length; i++) {				
				if(this.edit_img_url[i].name == file.name) {								
				   this.edit_img_url.splice(i, 1);
	                this.imgDel(file.name,false);
				   
				break;
				}
			 }
			}
		   
        
      },

	  handlePictureSuccess(response, file, fileList) {
      file.name=response.file_name;
	  file.url=response.file_url;
	  var obj={name:response.file_name,url:response.file_url};
		if (this.formStatus==0)
		{
		  this.editForm.img_url_tmp.push(obj);	  
		}
		if (this.formStatus==1)  
		{
			this.edit_img_url.push(obj);
		}
      },

	  handleVideoSuccess(response, file, fileList) {		
      file.name=response.file_name;
	  file.url=response.file_url;	
	  var obj={name:response.file_name,url:response.file_url};	 
	   
	  if (this.editForm.video.length>0)	
	  {		 
		  var f=this.editForm.video.pop();		
          this.fileDel(f.name,3);
	  }
	  	 
	  this.editForm.video.push(obj);
	  this.editForm.video_url=response.file_url;	
		 
		
      },
	  handleVideoRemove(file, fileList) {		     
           	
		  this.editForm.video.splice(0, 1);			  
          this.fileDel(file.name,3);	
		  this.editForm.video_url='';	
        
      },

	 handleAudioSuccess(response, file, fileList) {
		 
      file.name=response.file_name;
	  file.url=response.file_url;
	  var obj={name:response.file_name,url:response.file_url};	
	  if (this.editForm.audio.length>0)	
	  {		 
		  var f=this.editForm.audio.pop();		
         this.fileDel(f.name,2);
	  }	 
	   
		  this.editForm.audio.push(obj);	
		  this.editForm.audio_url=response.file_url;	  
      },
	  handleAudioRemove(file, fileList) {		     
           	
		  this.editForm.audio.splice(0, 1);			  
          this.fileDel(file.name,2);	
		  this.editForm.audio_url='';	
        
      },

	  
	 handleLyricSuccess(response, file, fileList) {
      file.name=response.file_name;
	  file.url=response.file_url;
	  var obj={name:response.file_name,url:response.file_url};	
	 
	  if (this.editForm.lyric_tmp.length>0)	
	  {
		 
		  var f=this.editForm.lyric_tmp.pop();
		
         this.fileDel(f.name,4);
	  }	 
		  this.editForm.lyric_tmp.push(obj);			 
		
      },
	  handleLyricRemove(file, fileList) {		     
           	
		  this.editForm.lyric_tmp.splice(0, 1);			  
          this.fileDel(file.name,4);	
		 
        
    },

	fileDel(filename,type){
                    
				
					var imgUrl=imgDel;
		           	this.$http.jsonp(imgUrl,{params: {CurrentUserID:CurrentUserID,Session:Session,fileName:filename,type:type,runType:runType}}).then(
						function(res){                         
							if (res.data.result_code!=200)
							{                           
								this.$message({
								message:'删除文件错误',
								type: 'error'
								});
							}
						},
						function(res)
						{
							this.$message({
									message:'删除文件错误',
									type: 'error'
									});
							
						});

	},
	showTypeChange(val)
	{
		
		if (this.formStatus==0)
		{
			this.editForm.duration='';
			this.editForm.play_name='';
			this.editForm.author='';
			if (this.editForm.lyric_tmp.length>0)	
			{
			   this.fileDel(this.editForm.lyric_tmp.pop().name,4);
			   this.editForm.lyric_tmp=[];                
			}

			if (this.editForm.video.length>0)	
			{
				this.fileDel(this.editForm.video.pop().name,3);
				this.editForm.video=[];
				this.editForm.video_url="";
			}

			if (this.editForm.audio.length>0)	
			{
				this.fileDel(this.editForm.audio.pop().name,3);
				this.editForm.audio=[];
				this.editForm.audio_url="";
			}
			
		}
		
		
	},

	articleChange(val)
	{
		if (val==null || val=='')
		{			
				this.editForm.article_url='';			
		}
		else
		{
				this.editForm.article_url=articleUrl+'?article_id='+val;
		}					
		
	},
		   
	getBase(){
			this.$http.jsonp(getDiscoveryInfoBase,{params: {CurrentUserID:CurrentUserID,Session:Session }}).then(
			function(res){                         
			if (res.data.result_code==200)
			{					
			
				this.showTypes=res.data.showTypes;	
				this.articles=res.data.articles;	

				
			}
			else{                           
				this.$message({
				message:'获取基础信息错误',
				type: 'error'
				});
			}
		

			},
			function(res)
			{
				this.$message({
						message:'获取基础信息错误',
						type: 'error'
						});
				
			});


	

	},
	getInfos() {
		let para = {
			CurrentUserID:CurrentUserID,
			currentPage: this.currentPage,
			pageSize:this.pageSize,
			title: this.filters.title,					
			sortName:this.prop,
			sortOrder:this.order,
			Session:Session
		};
		this.listLoading = true;				

		this.$http.jsonp(getDiscoveryListPage, {params: para}).then(
				function(res){                         
						if (res.data.result_code==200)
						{
							this.total = res.data.infolist.total;
							this.infos = res.data.infolist.infos;
							this.listLoading = false;
						
						}
						else{                           
							
							this.listLoading = false;
							
							if (res.data.result_code==911)
							{
								this.$router.push({ path: "/login"});
								return;
							}

							if (res.data.result_code==600)
							{
								this.$message({
									message:'接口错误',
									type: 'error'
								});
								return;
							}
						
						}
					

				},
                   function(res)
                   {
                        this.$message({
                                message:'接口访问失败',
                                type: 'error'
                              });
                      this.listLoading = false;
                   }
           )

			},
			//删除
			handleDel: function (index, row) {
				this.$confirm('确认删除该记录吗?', '提示', {
					type: 'warning'
				}).then(() => {
					this.listLoading = true;
					//NProgress.start();
					let para = { CurrentUserID:CurrentUserID,id: row.id,Session:Session };

                   this.$http.jsonp(removeDiscoveryInfo, {params: para}).then(
                   function(res){                         
                         if (res.data.result_code==200)
                         {
							this.listLoading = false;
							this.$message({
							message: '删除成功',
							type: 'success'
						    });
							this.getInfos();                           
                         }
                         else{                  
                             
							this.listLoading = false;
							if (res.data.result_code==911)
							  {
                                  this.$router.push({ path: "/login"});
								  return;
							  }

                              if (res.data.result_code==600)
							  {
									this.$message({
										message:'接口错误',
										type: 'error'
									});
                                  return;
							  }
							if  (res.data.result_code==914)
                            {
                              this.$message({
                                message:'没有删除权限',
                                type: 'error'
                              });
							   return;
							}
                             
                         }
                       

                   },
                   function(res)
                   {
                        this.$message({
                                message:'接口访问失败',
                                type: 'error'
                              });
                      this.listLoading = false;
                   });


				}
				
				).catch(() => {

				});
			},

			//发布
			handleRelease: function (index, row) {

				    sessionStorage.setItem('right', "1"); 
             	    this.$router.push({path: '/releaselist',query: {push_id:row.id,title:row.title,type:row.show_type_name}});
					sessionStorage.setItem('right', "0"); 
			},
			//显示编辑界面
			handleEdit: function (index, row) {
				
				this.formStatus=1;

				
				this.selectchangeflag=0;
				
				this.editForm = Object.assign({}, row); 

				

				this.editForm.stop_flag=this.editForm.stop_flag>0?true:false; 	
               // this.editForm.app_group_tmp=JSON.parse(row["app_group_tmp"]);
				//this.editForm.app_id_tmp=JSON.parse(row["app_id_tmp"]);	

				this.editForm.video=JSON.parse(row["video"]);	
				this.editForm.audio=JSON.parse(row["audio"]);	
				this.editForm.lyric_tmp=JSON.parse(row["lyric_tmp"]);	

				//this.getApp(this.editForm.app_group_tmp.join(','));
				//this.$set(this.editForm,"jump_params_tmp",JSON.parse(row["jump_params_tmp"]));
               this.$set(this.editForm,"img_url_tmp",JSON.parse(row["img_url_tmp"]));

				this.editFormVisible = true;

				let para = {
					CurrentUserID:CurrentUserID,					
				    currentPage: this.sentencePage,
					id:	row.id,				
					Session:Session};
				 this.$http.jsonp(getWordSubListPage, {params: para}).then(
                   function(res){                         
                         if (res.data.result_code==200)
                         {
							 
					         this.wordData = res.data.infolist.infos;
					         this.wordlistLoading = false;
                           
                         }
                         else{                           
                              
                             this.wordlistLoading = false;
							 
							 if (res.data.result_code==911)
							  {
                                 this.$router.push({ path: "/login"});
								  return;
							  }

                              if (res.data.result_code==600)
							  {
									this.$message({
										message:'接口错误',
										type: 'error'
									});
                                  return;
							  }
							
                         }
                       

                   },
                   function(res)
                   {
                        this.$message({
                                message:'接口访问失败',
                                type: 'error'
                              });
                      this.sentencelistLoading = false;
                   }
           )


      			
				
			},
			//显示新增界面
			handleAdd: function () {
				
				this.formStatus=0;
				
				this.editFormVisible = true;
				this.del_tmp=[];
			    this.edit_img_url=[];
				this.editForm = {
					id: 0,				
					title:'',
					content:'',					
					show_type:'1',                  
					img_url_tmp:[],
					article_id:'',	
					article_url:'',					
					play_name:'',
					author:'',
					duration:'',
					video:[],
					video_url:'',
					audio:[],
					audio_url:'',
					lyric_tmp:[],
					stop_flag:false,
					//words:'',
					keyword:''
				};

				this.wordData=[];
				this.wordTotal=0;
				this.wordSize=20;
                this.wordPage=1;
				this.sels=[];
				this.words=[];
				if (this.$refs['editForm'] !== undefined) {						
                    this.$refs['editForm'].resetFields();
                }			
                //this.$refs['editForm'].resetFields();
				
			},
			//编辑
			editSubmit: function () {

				this.$refs.editForm.validate((valid) => {
					if (valid) {

                        if (this.editForm.video.length==0 && this.editForm.audio.length==0 && this.editForm.article_id=="")
						{
                            this.$message({
										message:'音频、视频、文章必须选一个',
										type: 'error'
									});
							return ;
						}

						if (this.editForm.img_url_tmp.lenght==0)
						{
							this.$message({
										message:'请上传缩率图',
										type: 'error'
									});
							return ;
						}
							if (this.editForm.img_url_tmp.lenght>1)
						{
							this.$message({
										message:'缩率图只需上传一张',
										type: 'error'
									});
							return ;
						}

						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							this.editLoading = true;            

							let para = Object.assign({}, this.editForm);
							para["CurrentUserID"] = CurrentUserID;
							para["Session"]=Session;
							para["video"]=JSON.stringify(this.editForm.video);
							para["audio"]=JSON.stringify(this.editForm.audio);
							para["lyric_tmp"]=JSON.stringify(this.editForm.lyric_tmp);
							para["word"]=this.wordData;

                            var tmp_img=this.editForm.img_url_tmp.concat();
							for (var i=0;i<this.del_tmp.length;i++)
							{
							   for(var j=0; i<tmp_img.length; j++) {
								   if(tmp_img[j].name == this.del_tmp[i].name) {				  
												
											tmp_img.splice(j, 1);			  
											
										break;
								   }
								}
							}

							para["img_url_tmp"]=JSON.stringify(tmp_img.concat(this.edit_img_url));

               
						if (this.del_tmp.length>0){
							
				            this.imgDel(JSON.stringify(this.del_tmp),true);							
							this.del_tmp=[];
						}	


			   let infoUrl=	addDiscoveryInfo;			  
               if (this.formStatus==1)
			   {
                  infoUrl=editDiscoveryInfo;
			   }
              
				this.$http.post(infoUrl, para,{emulateJSON:false}).then(
                   function(res){                         
                         if (res.data.result_code==200)
                         {		
							this.wordData=[];
							this.wordTotal=0;
							this.wordSize=20;
							this.wordPage=1;
							this.sels=[];
							this.words=[];	

							this.editForm = {
								id: 0,							
								title:'',
								content:'',						
								show_type:'1',								
								img_url_tmp:[],
								article_id:'',
								article_url:'',									
								play_name:'',
								author:'',
								duration:'',
								video:[],
								video_url:'',	
								audio:[],
								audio_url:'',
								lyric_tmp:[],
								stop_flag:false,
					           // words:'',
					            keyword:''
							};		
							    this.edit_img_url=[];		    
							 	this.editLoading = false;								
								this.$message({
									message: '提交成功',
									type: 'success'
								});
								

								if (this.formStatus==1)
								{
								  this.editFormVisible = false;
								}
								this.getInfos();
                            
                         }
                         else{                           
                               this.editLoading = false;
							 if (res.data.result_code==911)
							  {
                                 this.$router.push({ path: "/login"});
								  return;
							  }

                              if (res.data.result_code==600)
							  {
									this.$message({
										message:'接口错误',
										type: 'error'
									});
                                  return;
							  }
							if  (res.data.result_code==912)
                            {
                              this.$message({
                                message:'没有新增权限',
                                type: 'error'
                              });
							   return;
							}
							if  (res.data.result_code==913)
                            {
                              this.$message({
                                message:'没有编辑权限',
                                type: 'error'
                              });
							   return;
							}
                         }
                       

                   },
                   function(res)
                   {
                        this.$message({
                                message:'接口访问失败',
                                type: 'error'
                              });
							  this.editLoading = false;	
                      
                   }
           )


						});
					}
				});
			},

			selsChange: function (sels) {
				this.sels = sels;
			},
			sortChange:function(order){
                   this.prop=order.prop;
				   this.order=order.order,
                 this.getInfos();
			},

			wordSortChange:function(order){
				this.wordprop=order.prop;
				this.wordorder=order.order,
				this.getword();
			},
			//批量删除
			batchRemove: function () {
				var ids = this.sels.map(item => item.id).toString();
				this.$confirm('确认删除选中记录吗？', '提示', {
					type: 'warning'
				}).then(() => {
					this.listLoading = true;
					//NProgress.start();
					
					let para = { ids: ids,CurrentUserID:CurrentUserID,Session:Session };
            

                   this.$http.jsonp(batchremoveDiscoveryInfo, {params: para}).then(
                   function(res){                         
                         if (res.data.result_code==200)
                         {
							this.listLoading = false;
							this.$message({
							message: '删除成功',
							type: 'success'
						    });
							this.getInfos();
                           
                         }
                         else{                           
                              
                             this.listLoading = false;
							 if (res.data.result_code==911)
							  {
                                  this.$router.push({ path: "/login"});
								  return;
							  }

                              if (res.data.result_code==600)
							  {
									this.$message({
										message:'接口错误',
										type: 'error'
									});
                                  return;
							  }
							if  (res.data.result_code==914)
                            {
                              this.$message({
                                message:'没有删除权限',
                                type: 'error'
                              });
							   return;
							}
                         }
                       

                   },
                   function(res)
                   {
                        this.$message({
                                message:'接口访问失败',
                                type: 'error'
                              });
                      this.listLoading = false;
                   });


				}).catch(() => {

				});
			}
		},
		mounted() {
			CurrentUserID=sessionStorage.getItem('userID')==null?0:sessionStorage.getItem('userID'); 
            Session=sessionStorage.getItem('session')==null?0:sessionStorage.getItem('session');	
			
			this.getBase();
			this.getInfos();
		
           
 	        
			
		}
	}

</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// pushdiscovery.vue?3efd596e